import type { CellData as RootCellData } from '../types';

import type { CurrencyISO } from '@/constants/currencies';

import type { getCellTemplate } from './utils';

export const kind = 'total-cost-cell' as const;

export interface TotalCostCellData
  extends RootCellData<typeof kind, number | null> {
  currencyISO: CurrencyISO | null;
}

export type TotalCostCell = ReturnType<typeof getCellTemplate>;
